import type { ReactNode } from 'react';
import { Character } from './ui';

export type CharacterMomentTone = 'ice' | 'gold' | 'violet' | 'mint' | 'rose' | 'navy';

export interface CharacterMomentProps {
  src: string;
  alt: string;
  eyebrow: string;
  title: string;
  copy: string;
  tone?: CharacterMomentTone;
  compact?: boolean;
  action?: ReactNode;
}

export function CharacterMoment({ src, alt, eyebrow, title, copy, tone = 'ice', compact = false, action }: CharacterMomentProps) {
  return (
    <section className={`character-moment tone-${tone} ${compact ? 'compact' : ''}`}>
      <div className="character-moment-art" aria-hidden={alt === '' ? true : undefined}>
        <Character src={src} alt={alt} className="character-moment-character" />
      </div>
      <div className="character-moment-copy">
        <span>{eyebrow}</span>
        <strong>{title}</strong>
        <p>{copy}</p>
        {action && <div className="character-moment-action">{action}</div>}
      </div>
    </section>
  );
}

export function CharacterMiniBadge({ src, alt, label, detail }: { src: string; alt: string; label: string; detail: string }) {
  return (
    <aside className="character-mini-badge">
      <Character src={src} alt={alt} />
      <span><strong>{label}</strong><small>{detail}</small></span>
    </aside>
  );
}
